



















import Vue from "vue";
import VueSimpleSpinner from 'vue-simple-spinner'

export default Vue.component('DataLoadCard', {
  props: {
    loadingData: {
      type: Boolean,
      required: true
    },
    cardTitle: {
      type: String
    }
  },
  components: {
    VueSimpleSpinner
  },
  data() {
    return {
      cardExpanded: false
    }
  },
  methods: {
    expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.$emit('do-data-load');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/DataLoadCard.vue